import React, { useEffect, useState } from 'react';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import { HiGlobeAmericas } from "react-icons/hi2"; 
import { FaCheck, FaTimes, FaRobot, FaUsers, FaStar } from "react-icons/fa";
// pricing page components
import PricingBox from '../pricing/PricingBox'
import '../../styles/Subscribed.css'
import { Link } from 'react-router-dom';

const baseUrl = process.env.REACT_APP_API_URL;

const Subscription = () => {
    const { user, setUser } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log("user when navigating to the page", user);
      }, [user?.email]);

    const handleReturnToProfile = () => {
      navigate('/profile');
    }

    const handleManageSubscription = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/handle-subscription`, {
                method: 'POST',
                body: JSON.stringify({ email: user?.email }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            const data = await response.json();
            if (response.ok && data.url) {
                window.location.href = data.url;
            } else {
                setError('Failed to create customer portal session', data);
            }
        } catch (err) {
        setError('Error managing subscription. Please try again later.');
            
    }
}
    if (!user) {
        return <div>Loading user data...</div>;
    }

return (
    <div className="flex flex-col min-h-screen w-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/images/leelo_landing.jpg')" }}>
    <div className="flex flex-col min-h-screen w-full bg-gradient-to-br from-white/30 to-uranian-blue/20 backdrop-blur-sm">
      <div className="w-full max-w-7xl mx-auto p-5 flex flex-col items-center justify-center">
        <header className="flex justify-end items-center mb-5 px-5 w-full">
          <div className="flex items-center gap-7">
            <span className="flex items-center gap-2 text-white">
              {user.city}, {user.state} <HiGlobeAmericas className="text-lg" />
            </span>
          </div>
        </header>
        
          <main className="flex-grow bg-gradient-to-br from-white/95 to-uranian-blue/80 backdrop-blur-sm shadow-xl rounded-lg py-16 px-12 w-full max-w-4xl mx-auto border border-white/20">
              <div className="subscribed-container flex flex-col justify-center items-center">
                <div className="text-center mb-8">
                  <h1 className="text-4xl font-bold text-gray-800 mb-4">Get More from Leelo</h1>
                  <p className="text-xl text-gray-600 mb-6">Upgrade to Premium and experience the difference</p>
                </div>

                {/* Feature Comparison Table */}
                <div className="w-full max-w-3xl mb-8">
                  {/* Desktop Table */}
                  <div className="hidden md:block bg-white/80 backdrop-blur-sm rounded-lg shadow-lg overflow-hidden">
                    <div className="grid grid-cols-3 divide-x divide-gray-200">
                      {/* Feature Column */}
                      <div className="p-6 bg-gradient-to-b from-uranian-blue/10 to-uranian-blue/5">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Features</h3>
                        <div className="space-y-4">
                          <div className="flex items-center gap-3">
                            <FaRobot className="text-uranian-blue text-xl" />
                            <span className="text-gray-700">AI Thought Partners</span>
                          </div>
                          <div className="flex items-center gap-3">
                            <FaUsers className="text-uranian-blue text-xl" />
                            <span className="text-gray-700">Matches at Once</span>
                          </div>
                          <div className="flex items-center gap-3">
                            <FaStar className="text-uranian-blue text-xl" />
                            <span className="text-gray-700">Priority Support</span>
                          </div>
                        </div>
                      </div>

                      {/* Free Plan */}
                      <div className="p-6 text-center flex flex-col">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Free</h3>
                        <div className="space-y-4 flex-grow">
                          <div className="flex justify-center">
                            <span className="text-gray-600 font-medium">1</span>
                          </div>
                          <div className="flex justify-center">
                            <span className="text-gray-600 font-medium">1</span>
                          </div>
                          <div className="flex justify-center">
                            <FaTimes className="text-red-500 text-xl" />
                          </div>
                        </div>
                        <p className="text-2xl font-bold text-gray-600 mt-6">$0<span className="text-sm text-gray-500">/month</span></p>
                      </div>

                      {/* Premium Plan */}
                      <div className="p-6 text-center bg-gradient-to-b from-tropical-indigo/10 to-tropical-indigo/5 border-l-4 border-tropical-indigo flex flex-col">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Premium</h3>
                        <div className="space-y-4 flex-grow">
                          <div className="flex justify-center">
                            <span className="text-tropical-indigo font-bold text-lg">3</span>
                          </div>
                          <div className="flex justify-center">
                            <span className="text-tropical-indigo font-bold text-lg">5</span>
                          </div>
                          <div className="flex justify-center">
                            <FaCheck className="text-green-500 text-xl" />
                          </div>
                        </div>
                        <p className="text-2xl font-bold text-tropical-indigo mt-6">$13.99<span className="text-sm text-gray-500">/month</span></p>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Comparison Cards */}
                  <div className="md:hidden space-y-4">
                    {/* Free Plan Card */}
                    <div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-lg p-6">
                      <div className="text-center mb-4">
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">Free Plan</h3>
                        <p className="text-3xl font-bold text-gray-600">$0<span className="text-sm text-gray-500">/month</span></p>
                      </div>
                      <div className="space-y-3">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FaRobot className="text-uranian-blue text-lg" />
                            <span className="text-gray-700">AI Thought Partners</span>
                          </div>
                          <span className="text-gray-600 font-medium">1</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FaUsers className="text-uranian-blue text-lg" />
                            <span className="text-gray-700">Matches at Once</span>
                          </div>
                          <span className="text-gray-600 font-medium">1</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FaStar className="text-uranian-blue text-lg" />
                            <span className="text-gray-700">Priority Support</span>
                          </div>
                          <FaTimes className="text-red-500 text-lg" />
                        </div>
                      </div>
                    </div>

                    {/* Premium Plan Card */}
                    <div className="bg-gradient-to-br from-tropical-indigo/10 to-tropical-indigo/5 backdrop-blur-sm rounded-lg shadow-lg p-6 border-2 border-tropical-indigo">
                      <div className="text-center mb-4">
                        <span className="bg-tropical-indigo text-white text-xs px-3 py-1 rounded-full font-medium mb-2 inline-block">RECOMMENDED</span>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">Premium Plan</h3>
                        <p className="text-3xl font-bold text-tropical-indigo">$13.99<span className="text-sm text-gray-500">/month</span></p>
                      </div>
                      <div className="space-y-3">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FaRobot className="text-uranian-blue text-lg" />
                            <span className="text-gray-700">AI Thought Partners</span>
                          </div>
                          <span className="text-tropical-indigo font-bold text-lg">3</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FaUsers className="text-uranian-blue text-lg" />
                            <span className="text-gray-700">Matches at Once</span>
                          </div>
                          <span className="text-tropical-indigo font-bold text-lg">5</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <FaStar className="text-uranian-blue text-lg" />
                            <span className="text-gray-700">Priority Support</span>
                          </div>
                          <FaCheck className="text-green-500 text-lg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Benefits Section */}
                <div className="w-full max-w-3xl mb-8">
                  <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Why Upgrade to Premium?</h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="bg-tropical-indigo/20 p-2 rounded-full">
                          <FaRobot className="text-tropical-indigo text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800">Multiple AI Partners</h3>
                      </div>
                      <p className="text-gray-600">Create up to 3 unique AI thought partners, Perfect for different aspects of your life - work, relationships, personal growth.</p>
                    </div>
                    
                    <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="bg-tropical-indigo/20 p-2 rounded-full">
                          <FaUsers className="text-tropical-indigo text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800">More Matches</h3>
                      </div>
                      <p className="text-gray-600">View up to 5 potential matches at once instead of just 1. Find your perfect connection faster with more options and better compatibility insights.</p>
                    </div>

                    <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="bg-tropical-indigo/20 p-2 rounded-full">
                          <FaUsers className="text-tropical-indigo text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800">Group Conversations</h3>
                      </div>
                      <p className="text-gray-600">Create group chats with your AI partners and friends. More AI partners means more dynamic group conversations and better collaboration.</p>
                    </div>
                  </div>
                </div>

                {/* CTA Section */}
                <div className="text-center mb-8">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">Ready to unlock more possibilities?</h2>
                  <p className="text-lg text-gray-600 mb-6">Join thousands of users who've upgraded to Premium</p>
                </div>

                <div className="account-button-container flex items-center justify-center gap-4">
                  <button onClick={handleManageSubscription} className='flex items-center justify-center gap-2 bg-tropical-indigo text-white border border-tropical-indigo hover:bg-tropical-indigo/90 rounded px-6 py-3 text-base font-medium cursor-pointer transition-colors'>
                    <FaStar className="text-sm" />
                    Manage Subscription
                  </button>
                  <button onClick={handleReturnToProfile} className='flex items-center justify-center gap-2 bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 rounded px-6 py-3 text-base font-medium cursor-pointer transition-colors'>
                    Return to Profile
                  </button>
                </div>
              </div>
            </main>
        
        <footer className="flex justify-between items-center py-6 px-8 w-full max-w-4xl mx-auto">
          <p className="text-xs text-white m-0 flex items-center">
            2025 © Wenzi, Inc. 
            <span className="mx-2">•</span> 
            <Link to="/privacy" className="text-white hover:underline">Privacy Policy</Link>
            <span className="mx-2">•</span> 
            <a href="https://discord.gg/z859AyVU3R" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Join our Discord</a>
          </p>
        </footer>
      </div>
    </div>
    </div>
    );
};

export default Subscription;
